"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("../../styles/layout/Table.css");
var _PaginationContainer = _interopRequireDefault(require("../common/Pagination/PaginationContainer"));
var _SimplePaginationContainer = _interopRequireDefault(require("../common/Pagination/SimplePaginationContainer"));
var _APIcon = _interopRequireDefault(require("./APIcon"));
var _Spinner = _interopRequireDefault(require("./Spinner/Spinner"));
var _excluded = ["selectedInstrument", "rowIndex"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var filterInvalid = function filterInvalid() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    selectedInstrument = _ref.selectedInstrument,
    rowIndex = _ref.rowIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  return rest;
};
var APTable = function APTable(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var title = props.title,
    columns = props.columns,
    baseClass = props.baseClass,
    rows = props.rows,
    empty = props.empty,
    onRowClicked = props.onRowClicked,
    fetching = props.fetching,
    headerOutside = props.headerOutside,
    pageSize = props.pageSize,
    minRow = props.minRow,
    alwaysShowPagination = props.alwaysShowPagination,
    rowProps = props.rowProps,
    selectedRow = props.selectedRow,
    componentName = props.componentName,
    usePagination = props.usePagination,
    showOnlyActivePage = props.showOnlyActivePage,
    useSimplePagination = props.useSimplePagination,
    nextPageEnabled = props.nextPageEnabled;
  var flexTable = (0, _cssClassesHelper.getBEMClasses)('flex-table');
  var customClass = baseClass || function () {
    return '';
  };
  var header = columns.map(function (col, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-test": col.dataTest,
      key: index,
      title: col.title || undefined,
      className: "".concat(flexTable('column'), " ").concat(customClass('header-column', col.classModifier))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('header-cell', headerOutside ? 'absolute' : 'fixed'), " ").concat(customClass('fixed', col.classModifier))
    }, col.header));
  });
  var emptyRow = function emptyRow() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('row', 'empty'), " ").concat(customClass('row-empty'))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('column', 'empty'), " ").concat(customClass('column-empty'))
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: "stop",
      customClass: "".concat(flexTable('empty-icon'), " ").concat(customClass('empty-icon'))
    }), empty));
  };
  var getTableRows = function getTableRows(data) {
    return data && data.length && data[0] === undefined ? data.map(function (row, rowIndex) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: rowIndex,
        className: "".concat(flexTable('row', 'no-hover'), " ").concat(customClass('row'))
      }, rowIndex === 0 && emptyRow());
    }) : data.map(function (row, rowIndex) {
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, row && filterInvalid(rowProps(row, rowIndex)), {
        onClick: function onClick() {
          return row && onRowClicked && onRowClicked(row);
        },
        key: rowIndex,
        className: "".concat(flexTable('row', !row && 'no-hover'), " ").concat(customClass('row', selectedRow.key && selectedRow.value === row[selectedRow.key] ? 'selected' : ''))
      }), row && columns.map(function (col, colIndex) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: col.style,
          key: col.accessor || colIndex,
          className: "".concat(flexTable('column'), " ").concat(customClass('column', col.classModifier))
        }, col.cell ? col.cell(row, rowProps(row, rowIndex)) : row[col.accessor]);
      }));
    });
  };
  var renderTable = function renderTable(data, containerClasses) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: flexTable('wide-row-container')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable(), " ").concat(customClass(), " ").concat(containerClasses)
    }, title && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('title'), " ").concat(customClass('table-title'))
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('header', 'background'), " ").concat(customClass('table-header', 'background'))
    }), headerOutside && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('header'), " ").concat(customClass('table-header', baseClass.classModifier))
    }, header), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('body'), " ").concat(customClass('body'))
    }, !headerOutside && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(flexTable('header', 'inside'), " ").concat(customClass('table-header', baseClass.classModifier))
    }, header), fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
      text: t("Loading..."),
      customClass: baseClass
    }) : data.length === 0 ? emptyRow() : getTableRows(data))));
  };
  var getMinimumOf = function getMinimumOf(data, min) {
    var emptyRows = min - data.length;
    return minRow && min && emptyRows > 0 ? [].concat(_toConsumableArray(data), _toConsumableArray(new Array(Math.min(minRow || emptyRows, emptyRows)))) : data;
  };
  var renderTableWithPagination = function renderTableWithPagination(totalPages, data) {
    var containerClasses = customClass('body', 'multipage');
    if (useSimplePagination) {
      return /*#__PURE__*/_react["default"].createElement(_SimplePaginationContainer["default"], {
        totalPages: totalPages,
        containerClassName: flexTable('pagination-container'),
        content: function content() {
          return renderTable(getMinimumOf(data, minRow || pageSize), containerClasses);
        },
        componentName: componentName,
        customClass: baseClass(),
        showOnlyActivePage: showOnlyActivePage,
        onRequestPrev: props.onRequestPrev,
        onRequestNext: props.onRequestNext,
        nextPageEnabled: nextPageEnabled
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_PaginationContainer["default"], {
      totalPages: alwaysShowPagination ? Infinity : totalPages,
      containerClassName: flexTable('pagination-container'),
      content: function content(page) {
        var rows = data.slice(pageSize * page, pageSize * (page + 1));
        return renderTable(getMinimumOf(rows, minRow || pageSize), containerClasses);
      },
      componentName: componentName,
      customClass: baseClass(),
      showOnlyActivePage: showOnlyActivePage
    });
  };
  var totalPages = Math.ceil(rows.length / pageSize || rows.length);
  var containerClasses = customClass('body', 'single-page');
  return usePagination && (alwaysShowPagination || pageSize && totalPages > 1) ? renderTableWithPagination(totalPages, rows) : renderTable(getMinimumOf(rows, minRow || pageSize), containerClasses);
};
APTable.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    accessor: _propTypes["default"].string,
    header: _propTypes["default"].string,
    cell: _propTypes["default"].func,
    width: _propTypes["default"].string,
    classModifier: _propTypes["default"].string
  })).isRequired,
  rows: _propTypes["default"].array.isRequired,
  rowProps: _propTypes["default"].func,
  empty: _propTypes["default"].string,
  onRowClicked: _propTypes["default"].func,
  baseClass: _propTypes["default"].func,
  fetching: _propTypes["default"].bool,
  minRow: _propTypes["default"].number,
  pageSize: _propTypes["default"].number,
  alwaysShowPagination: _propTypes["default"].bool,
  selectedRow: _propTypes["default"].object,
  usePagination: _propTypes["default"].bool,
  useSimplePagination: _propTypes["default"].bool
};
APTable.defaultProps = {
  headerOutside: true,
  rowProps: function rowProps(row, rowIndex) {
    return {
      rowIndex: rowIndex
    };
  },
  selectedRow: {
    key: '',
    value: ''
  },
  usePagination: true,
  useSimplePagination: false
};
var _default = exports["default"] = APTable;